import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Overlay from '../../../forms/_common/Overlay';
import { useQueryMutation } from '../../../../hooks/@lore/query-connect';
import Intent from './Intent';

EducatorIntentYes.propTypes = {
  userIntents: PropTypes.object
};

export default function EducatorIntentYes(props) {
  const {
    user,
    intents,
    userIntents,
    onSubmit,
    title = `Yes, that's me!`
  } = props;

  const educatorIntent = _.find(intents.data, intent => intent.data.name === 'Educator');

  const isEducator = !!_.find(userIntents.data, intent => intent.data.id === educatorIntent.id);

  const mutation_create = useQueryMutation('tagNode.create');
  const mutation_destroy = useQueryMutation('tagNode.destroy2');

  const saving = (
    mutation_create.isLoading ||
    mutation_destroy.isLoading
  );

  function onToggleIntent(intent) {
    const userIntent = _.find(userIntents.data, function(userIntent) {
      return userIntent._tag.id === intent.id;
    });

    if (!userIntent) {
      mutation_create.mutate({
        userId: user.id,
        tagId: intent.id
      }, {
        onSuccess: payload => {
          userIntents._add(payload);
          onSubmit();
        }
      });
    } else {
      mutation_destroy.mutate(userIntent._tagNode, {
        onSuccess: payload => {
          userIntents._remove(payload);
          onSubmit();
        }
      });
    }
  }

  function setEducatorIntent(active) {
    if (active && !isEducator) {
      onToggleIntent(educatorIntent);
    }

    if (!active && isEducator) {
      onToggleIntent(educatorIntent);
    }
  }

  return (
    <Overlay isVisible={saving}>
      <div className="flex flex-col space-x-0 space-y-6">
        <Intent
          title={title}
          onClick={() => {
            !isEducator ? setEducatorIntent(true) : onSubmit();
          }}
          // selected={isEducator}
          selected={false}
        />
      </div>
    </Overlay>
  );
}
